<template>
  <div>
    <p>{{ label }}</p>
    <input
      class="form-control"
      type="text"
      @input="$emit('update:getValue', $event.target.value)"
      name="commonTextInput"
    />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  emits: ["update:getValue"],
};
</script>

<style scoped>
p {
  margin-bottom: 10px;
}
input[type="text"] {
  max-width: 9rem;
  height: 2.375rem;
  font-size: 0.875rem;
  border: 2px solid rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px;
  color: rgb(95, 95, 95);
  padding: 0.375rem 0.75rem;
}
input[type="text"]:focus {
  outline-width: 0;
}
</style>
